var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',[_c('van-col',{attrs:{"span":"24"}},[_c('van-contact-card',{attrs:{"type":"edit","name":"张三","tel":"13000000000","editable":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }